import React from 'react';
import { Button, Badge, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

class HeatIndexCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temperature: 0,
      relativeHumidity: 0,
      heatIndex: 0,
      badgeBackgroundColor: '#ffff66',
      badgeTextColor: '#222222',
      badgeState: 'none',
      badgeText: 'Caution',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  handleSubmit(event) {
    var tempInFahrenheit = 1.80 * this.state.temperature + 32.0;
    var HI = tempInFahrenheit;
    if (parseFloat(HI) > 40.0) {
      var halfHI = 61.0 + (tempInFahrenheit - 68.0) * 1.2 + this.state.relativeHumidity * 0.094;
      var simpleHI = 0.5 * (parseFloat(tempInFahrenheit) + halfHI);
      if (simpleHI > 79.0) {
        HI = -42.379 + 2.04901523 * tempInFahrenheit + 10.14333127 * this.state.relativeHumidity - 0.22475541 * tempInFahrenheit * this.state.relativeHumidity - 6.83783 * (Math.pow(10, -3)) * (Math.pow(tempInFahrenheit, 2)) - 5.481717 * (Math.pow(10, -2)) * (Math.pow(this.state.relativeHumidity, 2)) + 1.22874 * (Math.pow(10, -3)) * (Math.pow(tempInFahrenheit, 2)) * this.state.relativeHumidity + 8.5282 * (Math.pow(10, -4)) * tempInFahrenheit * (Math.pow(this.state.relativeHumidity, 2)) - 1.99 * (Math.pow(10, -6)) * (Math.pow(tempInFahrenheit, 2)) * (Math.pow(this.state.relativeHumidity, 2));
        if (this.state.relativeHumidity <= 13 &&
          tempInFahrenheit >= 80.0 && tempInFahrenheit <= 112.0) {
          var adj1 = (13.0 - this.state.relativeHumidity) / 4.0;
          var adj2 = Math.sqrt((17.0 - Math.abs(tempInFahrenheit - 95.0)) / 17.0);
          var adj = adj1 * adj2;
          HI = HI - adj;
        }
        else if (this.state.relativeHumidity > 85.0 &&
          tempInFahrenheit >= 80.0 && tempInFahrenheit <= 87.0) {
          var adj1 = (this.state.relativeHumidity - 85.0) / 10.0;
          var adj2 = (87.0 - tempInFahrenheit) / 5.0;
          var adj = adj1 * adj2;
          HI = HI + adj;
        }
      } else {
        HI = simpleHI;
      }
    }
    var HIinCelsius = Math.round((HI - 32) * 0.556);
    var newBadgeBackgroundColor = '#ffff66';
    var newBadgeTextColor = '#222222';
    var newBadgeState = 'none';
    var newBadgeText = 'Caution';
    if (HIinCelsius >= 26) {
      newBadgeState = 'inline';
      if (HIinCelsius >= 32 && HIinCelsius < 41) {
        newBadgeBackgroundColor = '#ffd700';
        newBadgeText = 'Extreme caution';
      } else if (HIinCelsius >= 41 && HIinCelsius < 54) {
        newBadgeBackgroundColor = '#ff8c00';
        newBadgeTextColor = '#efefef';
        newBadgeText = 'Danger';
      } else if (HIinCelsius >= 54) {
        newBadgeBackgroundColor = '#ff0000';
        newBadgeTextColor = '#efefef';
        newBadgeText = 'Extreme danger';
      }
    }
    this.setState({
      heatIndex: HIinCelsius,
      badgeBackgroundColor: newBadgeBackgroundColor,
      badgeTextColor: newBadgeTextColor,
      badgeState: newBadgeState,
      badgeText: newBadgeText
    });
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  resetForm(event) {
    this.setState({
      tempInFahrenheit: 0,
      relativeHumidity: 0,
      heatIndex: 0,
      badgeState: 'none'
    })
  }

  render() {
    return (
      <div class="container">
        <h3>Heat Index Calculator</h3>
        <Form>
          <Row>
            <Col sm="12" md={{ size: 3, offset: 3 }}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label className="mr-sm-2">Air Temperature (°C)</Label>
                <Input type="number" step="any" name="temperature" onChange={this.handleInputChange} value={this.state.temperature}/>
              </FormGroup>
            </Col>
            <Col md={{ size: 3 }}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label className="mr-sm-2">Relative Humidity (%)</Label>
                <Input type="number" step="any" min="0" max="100" name="relativeHumidity" onChange={this.handleInputChange} value={this.state.relativeHumidity}/>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: '15px' }}>
            <Col sm="12" md={{ size: 2, offset: 4 }}>
              <Button type='button' block outline color="secondary" onClick={this.handleSubmit}>Calculate</Button>
            </Col>
            <Col md={{ size: 2 }}>
              <Button type='reset' block outline color="secondary" onClick={this.resetForm}>Reset</Button>
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col sm="12" md={{ size: 4, offset: 4 }} align="center">
              <span>Heat Index = {this.state.heatIndex} °C </span>
              <Badge style={{backgroundColor: this.state.badgeBackgroundColor, color: this.state.badgeTextColor, display: this.state.badgeState}} pill>{this.state.badgeText}</Badge>
            </Col>
          </Row>
        </Form>
        <hr />
        <p>
          We calculated heat index (HI) choosing&nbsp;
          <a href="https://www.wpc.ncep.noaa.gov/html/heatindex_equation.shtml">equations</a>
          &nbsp;of the U.S. National Weather Service (NWS).
          NWS specified the following health-relevant HI <a href="https://www.wrh.noaa.gov/psr/general/safety/heat/heatindex.png">categorization</a>:
          <ul>
            <li>
              Caution (27–32°C): fatigue is possible with prolonged exposure and physical activity,
            </li>
            <li>
              Extreme caution (32–41°C): sunstroke, muscle cramps, and heat exhaustion are possible,
            </li>
            <li>
              Danger (41–54°C): heat cramps and heat exhaustion are likely; heat stroke is probable, and
            </li>
            <li>
              Extreme danger (above 54°C): heat stroke likely.
            </li>
          </ul>
        </p>
      </div>
    );
  }
}

export default HeatIndexCalculator;